import React from 'react';
import { babyface } from '../CDNUrl';
import { PERIOD_REVIEW_CONTEST } from '../../../domain/event/EventReviewContestData';

import useEvent from '../../../Hooks/useEvent';
import { NotiIconImage } from '../../../components/common/atom/NotiIconImage';

export const isReviewContestOn = () => {
  const { startDate, endDate } = PERIOD_REVIEW_CONTEST;

  const { isHomeBannerOn } = useEvent().isEventItemOn({ startDate, endDate });

  return isHomeBannerOn;
};

const EventReviewContestIcon = ({ position = 'center' }) => {
  return (
    isReviewContestOn() && (
      <NotiIconImage
        src={`${babyface}/event/review_contest_noti_icon_${position}.png`}
        alt="생후 후기 리뷰 콘테스트 안내 아이콘"
      />
    )
  );
};

export default EventReviewContestIcon;